import React, { useState, useEffect } from 'react';
import { Button, Col, Row, Form, InputGroup, FormControl, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagingNav from '../component/PagingNav';
import { getUserSession } from '../component/userInfo';

const TitleImageList = () => {
    const [list, setList] = useState([]);
    const [paging, setPaging] = useState(null);
    const [perpage, setPerpage] = useState(10);
    const [keyword, setKeyword] = useState('');
    const [searchCol, setSearchCol] = useState('title');
    const [checkedItems, setCheckedItems] = useState([]);
    const [publishTarget, setPublishTarget] = useState('prod');

    useEffect(() => {
        fetchList(1);
    }, [perpage]);

    const handleSearch = () => {
        fetchList(1);
    }

    const fetchList = async (page) => {
        const userSession = getUserSession();
        try {
            const formData = new FormData();
            formData.append('action', 'list');
            formData.append('perpage', perpage);
            formData.append('page', page);
            formData.append('column', searchCol);
            formData.append('keyword', keyword);

            let res = await fetch('https://work.wekoinonia.org/json/titleImage.php', {
                method: 'POST',
                body: formData,
            });

            let json = await res.json();
            if (json.list) {
                setList(json.list);
                setPaging(json.paging);
                setCheckedItems([]);
            } else {
                setList([]);
                setPaging(null);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('정말로 삭제하시겠습니까?')) {
            const userSession = getUserSession();
            const formData = new FormData();
            formData.append('action', 'delete');
            formData.append('id', id);
            formData.append('uid', userSession.uid);

            try {
                let res = await fetch('https://work.wekoinonia.org/json/titleImage.php', {
                    method: 'POST',
                    body: formData,
                });
                let json = await res.json();
                if (json.code === '0000') {
                    alert('삭제되었습니다.');
                    fetchList(1);
                } else {
                    alert('삭제 중 오류가 발생했습니다.');
                }
            } catch (error) {
                console.error('Error:', error);
            }
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allIds = list.map(item => item.id);
            setCheckedItems(allIds);
        } else {
            setCheckedItems([]);
        }
    };

    const handleSelectItem = (e, id) => {
        if (e.target.checked) {
            setCheckedItems([...checkedItems, id]);
        } else {
            setCheckedItems(checkedItems.filter(item => item !== id));
        }
    };

    const handleBulkPublish = async (status) => {
        if (checkedItems.length === 0) {
            alert('선택된 항목이 없습니다.');
            return;
        }

        const statusText = status === 'Y' ? '발행' : '발행 취소';
        const targetText = publishTarget === 'prod' ? '운영' : '테스트';

        if (window.confirm(`선택된 항목을 ${targetText}에 ${statusText}하시겠습니까?`)) {
            const formData = new FormData();
            formData.append('action', 'bulk_publish');
            formData.append('ids', checkedItems.join(','));
            formData.append('target', publishTarget);
            formData.append('status', status);

            try {
                const res = await fetch('https://work.wekoinonia.org/json/titleImage.php', {
                    method: 'POST',
                    body: formData,
                });
                const json = await res.json();
                if (json.code === '0000') {
                    alert('처리되었습니다.');
                    fetchList(paging.page);
                } else {
                    alert('오류가 발생했습니다: ' + json.msg);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        }
    };

    return (
        <div className="container-fluid">
            <h1 className="h3 mb-2 text-gray-800">타이틀 이미지 관리</h1>
            <div className="card shadow mb-4">
                <div className="card-body">
                    <Row className="mb-3">
                        <Col md={2}>
                            <Form.Select value={perpage} onChange={e => setPerpage(e.target.value)}>
                                <option value={10}>10개씩 보기</option>
                                <option value={20}>20개씩 보기</option>
                                <option value={50}>50개씩 보기</option>
                            </Form.Select>
                        </Col>
                        <Col md={4}>
                            <InputGroup>
                                <Form.Select value={searchCol} onChange={e => setSearchCol(e.target.value)} style={{ flex: 0.5 }}>
                                    <option value="title">제목</option>
                                </Form.Select>
                                <FormControl
                                    placeholder="검색어 입력"
                                    value={keyword}
                                    onChange={e => setKeyword(e.target.value)}
                                    onKeyPress={e => e.key === 'Enter' && handleSearch()}
                                />
                                <Button onClick={handleSearch}>검색</Button>
                            </InputGroup>
                        </Col>
                        <Col md={6} className="text-end">
                            <Link to="/TitleImageForm">
                                <Button variant="primary">신규 등록</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={4}>
                            <InputGroup>
                                <Form.Select value={publishTarget} onChange={e => setPublishTarget(e.target.value)} style={{ flex: 0.5 }}>
                                    <option value="prod">운영</option>
                                    <option value="test">테스트</option>
                                </Form.Select>
                                <Button variant="success" onClick={() => handleBulkPublish('Y')}>발행</Button>
                                <Button variant="danger" onClick={() => handleBulkPublish('N')}>발행 취소</Button>
                            </InputGroup>
                        </Col>
                    </Row>
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th><Form.Check type="checkbox" onChange={handleSelectAll} /></th>
                                <th>ID</th>
                                <th>제목</th>
                                <th>공개시작일시</th>
                                <th>운영발행여부</th>
                                <th>테스트발행여부</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list.length > 0 ? list.map(item => (
                                <tr key={item.id}>
                                    <td><Form.Check type="checkbox" checked={checkedItems.includes(item.id)} onChange={e => handleSelectItem(e, item.id)} /></td>
                                    <td>{item.id}</td>
                                    <td><Link to={`/TitleImageForm?id=${item.id}`}>{item.title}</Link></td>
                                    <td>{item.release_date}</td>
                                    <td>{item.prod_publish_yn}</td>
                                    <td>{item.test_publish_yn}</td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="6" className="text-center">데이터가 없습니다.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    {paging && <PagingNav paging={paging} callback={fetchList} />}
                </div>
            </div>
        </div>
    );
};

export default TitleImageList;